export type ContentInputType = {
  article: string | undefined;
  grade: string | undefined;
  chapter?: string | undefined;
};

export enum Filter {
  ABOVE,
  EQUAL,
  BELOW,
}

export function compareGradeChapter(v1: string, v2: string): number {
  const [grade1, chapter1] = v1.split('.').map(parseFloat);
  const [grade2, chapter2] = v2.split('.').map(parseFloat);

  if (grade1 !== grade2) {
    return grade1 - grade2;
  } else {
    if (chapter1 && chapter2) {
      return chapter1 - chapter2;
    } else if (chapter1) {
      return chapter1;
    } else if (chapter2) {
      return 0 - chapter2;
    } else {
      return 0;
    }
  }
}

export function filterGradeChapter(
  data: { [key: string]: { [key: string]: string[] } },
  gradeChapter: string,
  filter: Filter,
): { [key: string]: string[] } {
  return Object.entries(data)
    .filter(([key]) => {
      if (filter === Filter.EQUAL) {
        return compareGradeChapter(key, gradeChapter) === 0;
      } else if (filter === Filter.ABOVE) {
        return compareGradeChapter(key, gradeChapter) > 0;
      } else {
        return compareGradeChapter(key, gradeChapter) < 0;
      }
    })
    .reduce((result, [key, value]) => {
      result = { ...result, ...value };
      return result;
    }, {});
}

export const parseAndDisplayPinyin = ({
  article,
  grade,
  chapter,
}: ContentInputType): string => {
  if (!article || !grade) {
    return '';
  }

  const pinyinKey = chapter ? `${grade}.${chapter}` : `${grade}`;
  const pinYinMapperByGradeAndChapter = require('src/dictionary/hanzi_pinyin_list.json');
  const pinYinMapperForAll = require('src/dictionary/hanzi_pinyin.json');
  const characters = article.split('');
  const pinYinMapperAbove = filterGradeChapter(
    pinYinMapperByGradeAndChapter,
    pinyinKey,
    Filter.ABOVE,
  );
  const pinYinMapperEqual = filterGradeChapter(
    pinYinMapperByGradeAndChapter,
    pinyinKey,
    Filter.EQUAL,
  );
  const pinYinMapperBelow = filterGradeChapter(
    pinYinMapperByGradeAndChapter,
    pinyinKey,
    Filter.BELOW,
  );
  const pinyinArticle = characters.map((char: string) => {
    if (
      (pinYinMapperEqual && pinYinMapperEqual[char]) ||
      (pinYinMapperBelow && pinYinMapperBelow[char])
    ) {
      return char;
    } else if (pinYinMapperAbove && pinYinMapperAbove[char]) {
      // put all pronunciations for polyphonic characters and user can edit
      return `${char}(${pinYinMapperAbove[char]})`;
    } else {
      if (pinYinMapperForAll && pinYinMapperForAll[char]) {
        return `${char}(${pinYinMapperForAll[char]})`;
      } else {
        return char;
      }
    }
  });

  return pinyinArticle.join('').trim();
};
